import React from 'react';
export function TomoCards() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const tomos = [{
    color: 'from-red-600 to-red-800',
    border: 'border-red-500',
    title: 'Fundamentos',
    emoji: '🎹'
  }, {
    color: 'from-blue-600 to-blue-800',
    border: 'border-blue-500',
    title: 'Ritmo',
    emoji: '🥁'
  }, {
    color: 'from-purple-600 to-purple-800',
    border: 'border-purple-500',
    title: 'Acordes',
    emoji: '🎵'
  }, {
    color: 'from-green-600 to-green-800',
    border: 'border-green-500',
    title: 'Lectura',
    emoji: '📖'
  }, {
    color: 'from-yellow-500 to-yellow-700',
    border: 'border-yellow-400',
    title: 'Repertorio',
    emoji: '🎶'
  }, {
    color: 'from-orange-500 to-orange-700',
    border: 'border-orange-400',
    title: 'Creatividad',
    emoji: '💡'
  }];
  return <section className="bg-[#0a1128] py-4 px-3 border-y border-[#1e293b]" data-id="element-173">
      <div className="max-w-4xl mx-auto" data-id="element-174">
        <h3 className="text-center text-gray-400 font-bold uppercase tracking-widest mb-3 text-xs" data-id="element-175">
          VISTA RÁPIDA DE LOS 6 TOMOS
        </h3>

        <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-176">
          {tomos.map((tomo, i) => <div key={i} onClick={scrollToPricing} className={`flex-shrink-0 w-28 md:w-36 bg-gradient-to-b ${tomo.color} bg-opacity-20 border ${tomo.border} rounded-lg p-2.5 text-center cursor-pointer transform hover:-translate-y-1 transition-transform duration-300`} data-id="element-177">
              <div className="text-2xl mb-1" data-id="element-178">{tomo.emoji}</div>
              <h4 className="text-white font-black text-xs md:text-sm leading-tight mb-1" data-id="element-179">
                {tomo.title}
              </h4>
              <p className="text-white/60 text-[9px] md:text-[10px] font-semibold leading-tight" data-id="element-180">
                Kit Completo Teclado Listo
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}